import { ChangeDetectorRef, Component, Input, ViewChild } from '@angular/core';
import { SectionHeaderComponent } from '../../../common/section-header/section-header.component';

import { DynamicForm } from '../../../../models/dynamic-form';
import { CONTACT_ACTIONS, ContactActions, ContactService } from '../../../../services/masters/contact.service';

import tdsFormConfig from "../config/tds-form-config.json"
import msmeFormConfig from "../config/msme-form-config.json"
import lutFormConfig from "../config/lut-form-config.json"
import { FormBuilder, FormGroup } from '@angular/forms';
import { DynamicFormService } from '../../../../services/dynamic-form.service';
import { ContactInformation, LutInfo, MsmeInfo, TdsInfo } from '../../../../models/masters/contact-information.interface';
import { DynamicFormComponent } from '../../../dynamic-form/dynamic-form.component';
import { SharedModule } from '../../../../modules/shared/shared.module';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { FileUploadService } from '../../../../services/file-upload.service';
import { act } from '@ngrx/effects';
import { FileEntity } from '../../../../models/common-model.interface';

@Component({
  selector: 'app-finance-compliance',
  standalone: true,
  imports: [SectionHeaderComponent, DynamicFormComponent, SharedModule, FileUploadComponent],
  templateUrl: './finance-compliance.component.html',
  styleUrl: './finance-compliance.component.scss'
})
export class FinanceComplianceComponent {

  @Input() action: ContactActions = CONTACT_ACTIONS.ADD;
  @Input() contactInformation!: ContactInformation;

  formGroup!: FormGroup;
  tdsFormConfig!: DynamicForm;
  msmeFormConfig!: DynamicForm;
  lutFormConfig!: DynamicForm;
  viewMode: boolean = false;

  tdsAttachment: FileEntity[] = [];
  msmeAttachment: FileEntity[] = [];
  lutAttachment: FileEntity[] = [];

  allowedFileTypes: string[] = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "text/pdf"
  ];

  @ViewChild('tdsForm') tdsFormComponent?: DynamicFormComponent;
  @ViewChild('msmeForm') msmeFormComponent?: DynamicFormComponent;
  @ViewChild('lutForm') lutFormComponent?: DynamicFormComponent;



  constructor(private fb: FormBuilder,
    private dynamicFormService: DynamicFormService,
    private fileUploadService: FileUploadService,
  ) {
    this.tdsFormConfig = tdsFormConfig as DynamicForm;
    this.msmeFormConfig = msmeFormConfig as DynamicForm;
    this.lutFormConfig = lutFormConfig as DynamicForm;

    this.formGroup = this.fb.group({
      tds: [this.fb.group({})],
      msme: [this.fb.group({})],
      lut: [this.fb.group({})]
    });
    this.initForm();
  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    this.viewMode = this.action === CONTACT_ACTIONS.VIEW;
    this.patchForm();
  }

  getTdsForm(): FormGroup {
    return this.formGroup.get('tds')?.value as FormGroup;
  }

  getMsmeForm(): FormGroup {
    return this.formGroup.get('msme')?.value as FormGroup;
  }

  getLutForm(): FormGroup {
    return this.formGroup.get('lut')?.value as FormGroup;
  }

  private initForm(): void {
    this.dynamicFormService.addControlsToForm(this.getTdsForm(), this.tdsFormConfig);
    this.dynamicFormService.addControlsToForm(this.getMsmeForm(), this.msmeFormConfig);
    this.dynamicFormService.addControlsToForm(this.getLutForm(), this.lutFormConfig);
  }

  private patchForm(): void {
    if (!this.contactInformation) return;
    
    this.patchTDSDetails(this.contactInformation?.tdsMetadata);
    this.patchMSMEDetails(this.contactInformation?.msmeInfo);
    this.patchLUTDetails(this.contactInformation?.lutInfo);

    if (this.viewMode) {
      this.getLutForm().disable();
      this.getMsmeForm().disable();
      this.getTdsForm().disable();
    }
  }

  patchTDSDetails(tdsData: TdsInfo | undefined): void {
    if (!tdsData || this.action === CONTACT_ACTIONS.CLONE) return;
    this.getTdsForm().patchValue({
      ...tdsData
    });
    const tdsFile = tdsData?.file ? tdsData.file : this.fileUploadService.convertToFileFromDTO(tdsData?.uploadedFile);
    this.tdsAttachment = tdsFile ? [tdsFile] : [];
  }

  patchMSMEDetails(msmeData: MsmeInfo | undefined): void {
    if (!msmeData || this.action === CONTACT_ACTIONS.CLONE) return;
    this.getMsmeForm().patchValue({...msmeData});
    const msmeFile = msmeData?.file ? msmeData.file : this.fileUploadService.convertToFileFromDTO(msmeData?.uploadedFile);
    this.msmeAttachment = msmeFile ? [msmeFile] : [];
  }

  patchLUTDetails(lutData: LutInfo | undefined): void {
    if (!lutData || this.action === CONTACT_ACTIONS.CLONE) return;
    this.getLutForm().patchValue({...lutData});
    const lutFile = lutData?.file ? lutData.file : this.fileUploadService.convertToFileFromDTO(lutData?.uploadedFile);
    this.lutAttachment = lutFile ? [lutFile] : [];
  }

  handleValueChange(event: any) {

  }

  onTdsFileChange(file: FileEntity[]) {
    if (this.contactInformation?.tdsMetadata?.fileId) {
      delete this.contactInformation.tdsMetadata.fileId;
    }
  }

  onMsmeFileChange(file: FileEntity[]) {
    if (this.contactInformation?.msmeInfo?.fileId) {
      delete this.contactInformation.msmeInfo.fileId;
    }
  }

  onLutFileChange(file: FileEntity[]) {
    if (this.contactInformation?.lutInfo?.fileId) {
      delete this.contactInformation.lutInfo.fileId;
    }
  }

  markAllAsTouched() {
    this.getLutForm().markAllAsTouched();
    this.getMsmeForm().markAllAsTouched();
    this.getTdsForm().markAllAsTouched();
  }

  isFormValid(): boolean {
    return this.getLutForm().valid && this.getMsmeForm().valid && this.getTdsForm().valid;
  }
}
